import { useDebounceFn, useMemoizedFn } from 'ahooks';
import { Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useAppDispatch } from 'app/hooks';
import RevxSvcContent from 'components/RevxConfigSvc/RevxSvcContent';
import {
  ExclusiveTypeEnum,
  JobConfigSvcOptionType,
  JobOptionDef,
  JobOptionSvc,
} from 'domains/jobconfigDomain';
import { OrientationEnum, SvcShowTypeEnum } from 'domains/skuDomain';
import { isArray } from 'lodash-es';
import {
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from 'react';
import { jobPartSvcHideBorder } from 'utils/jobConfig';
import { StepComponentSvcProps } from '../SingleWizardStep';
import './JobOptionRender.less';

export const JobOptionRender = (props: StepComponentSvcProps) => {
  const { sku, onRef, disabled, showType } = props;
  // const { t } = useTranslation();
  const [form] = useForm();
  const dispatch = useAppDispatch();
  useImperativeHandle(onRef, () => {
    return {
      submit: submit,
    };
  });

  const [formCache, setFormCache] = useState<{ [x: string]: any }>();
  const [formValue, setFormValue] = useState<{ [x: string]: any }>();

  const [allSvc, setAllSvc] = useState<JobOptionSvc[]>();

  const [optionSvc, setOptionSvc] = useState<JobConfigSvcOptionType>();
  const componentDate = {
    form,
    formCache,
    formValue,
    orientation: OrientationEnum.landscape,
  };

  const formChange = (
    value: { [x: string]: any },
    allValue: { [x: string]: any }
  ) => {
    setFormCache(allValue);
    setFormValue(value);
    cancelDebounceSubmit();
    debounceSubmit();
  };

  const submit = useMemoizedFn(async () => {
    try {
      const formData = await form.validateFields();
      let payload: any[] = [];
      if (
        [SvcShowTypeEnum.JOB_OPTIONS, SvcShowTypeEnum.REQUIRED].includes(
          showType
        )
      ) {
        Object.keys(formData).forEach((key) => {
          let svc: JobOptionSvc | undefined;
          let specDefs: any[] = [];
          if (key === 'bundling') {
            svc = allSvc?.find((svc) => svc.id === +formData.bundling.svc);
          } else if (formData[key]?.svc) {
            svc = allSvc?.find((svc) => svc.id === +formData[key].svc);
          } else {
            svc = allSvc?.find((svc) => svc.id === +key);
          }
          const options = svc?.options?.map((option) => {
            return {
              label: option.label || '',
              values: isArray(formData[key][option.label] || '')
                ? formData[key][option.label]
                : [formData[key][option.label] || ''],
            };
          });

          if (!svc?.parameterLabels || !svc?.parameterLabels.length) {
            if (svc?.specs[0].parameters) {
              specDefs = [
                {
                  parameters: svc?.specs[0].parameters,
                },
              ];
            }
          } else {
            if (svc?.specs.length === 1) {
              specDefs = [
                {
                  parameters: svc?.specs[0].parameters,
                },
              ];
            } else {
              let parameters: { label: string; parameter: any }[] = [];
              if (svc?.revxId === 15) {
                formData[key]?.['perforate'].forEach(
                  (perforate: { [x: string]: any }) => {
                    for (const i in perforate) {
                      if (!['page', 'rangeStart', 'rangeTo'].includes(i)) {
                        parameters.push({
                          label: i,
                          parameter: perforate[i],
                        });
                      }
                    }
                    specDefs.push({
                      parameters: parameters,
                      perforateRange:
                        perforate?.['page'] !== 'All'
                          ? {
                              from: perforate?.['rangeStart'],
                              to: perforate?.['rangeTo'],
                            }
                          : null,
                    });
                    parameters = [];
                  }
                );
              } else {
                for (const i in formData[key]?.spec) {
                  parameters.push({
                    label: i,
                    parameter: formData[key]?.spec[i],
                  });
                }
                specDefs = [
                  {
                    parameters: parameters,
                  },
                ];
              }
              // svc?.specs.forEach((spec) => {
              //   const conform = spec.parameters.map((parameter) => {
              //     if (
              //       parameter.parameter !==
              //       requireFormData[key]?.spec?.[parameter.label]
              //     ) {
              //       return false;
              //     }
              //     return true;
              //   });
              //   if (!conform.includes(false)) {
              //     specDefs = [
              //       {
              //         parameters: spec.parameters
              //       }
              //     ];
              //   }
              // });
            }
          }
          if (svc) {
            const payloadItem = {
              ...svc,
              ...formData[key],
              options,
              specDefs,
              name: svc.name,
            };
            payloadItem['svcId'] = payloadItem.id;
            delete payloadItem.id;
            payload.push(payloadItem);
          }
        });
      } else {
        let optionFormData: { [x: string]: any } = {};
        for (let i in formData) {
          if (formData[i] && formData[i].name?.length) {
            optionFormData[i] = formData[i];
          }
        }

        Object.keys(optionFormData).forEach((key) => {
          let svc: JobOptionSvc | undefined;
          if (key === 'bundling') {
            svc = allSvc?.find((svc) => svc.id === +formData.bundling.svc);
          } else if (formData[key]?.svc) {
            svc = allSvc?.find((svc) => svc.id === +formData[key].svc);
          } else {
            svc = allSvc?.find((svc) => svc.id === +key);
          }
          let specDefs: any[] = [];
          const options = svc?.options?.map((option) => {
            return {
              label: option.label || '',
              values: isArray(formData[key][option.label] || '')
                ? formData[key][option.label]
                : [formData[key][option.label] || ''],
            };
          });
          if (!svc?.parameterLabels || !svc?.parameterLabels.length) {
            if (svc?.specs[0].parameters) {
              specDefs = [
                {
                  parameters: svc?.specs[0].parameters,
                },
              ];
            }
          } else {
            if (svc?.specs.length === 1) {
              specDefs = [
                {
                  parameters: svc?.specs[0].parameters,
                },
              ];
            } else {
              let parameters: { label: string; parameter: any }[] = [];
              if (svc?.revxId === 15) {
                formData[key]?.['perforate']?.forEach(
                  (perforate: { [x: string]: any }) => {
                    for (const i in perforate) {
                      if (!['page', 'rangeStart', 'rangeTo'].includes(i)) {
                        parameters.push({
                          label: i,
                          parameter: perforate[i],
                        });
                      }
                    }
                    specDefs.push({
                      parameters: parameters,
                      perforateRange:
                        perforate?.['page'] !== 'All'
                          ? {
                              from: perforate?.['rangeStart'],
                              to: perforate?.['rangeTo'],
                            }
                          : null,
                    });
                    parameters = [];
                  }
                );
              } else {
                for (const i in formData[key]?.spec) {
                  parameters.push({
                    label: i,
                    parameter: formData[key]?.spec[i],
                  });
                }
                specDefs = [
                  {
                    parameters: parameters,
                  },
                ];
              }
              // svc?.specs.forEach((spec) => {
              //   const conform = spec.parameters.map((parameter) => {
              //     if (
              //       parameter.parameter !==
              //       optionFormData[key]?.spec?.[parameter.label]
              //     ) {
              //       return false;
              //     }
              //     return true;
              //   });
              //   if (!conform.includes(false)) {
              //     specDefs = [
              //       {
              //         parameters: spec.parameters
              //       }
              //     ];
              //   }
              // });
            }
          }
          if (svc) {
            const payloadItem = {
              ...svc,
              ...formData[key],
              options,
              specDefs,
              name: svc.name,
            };
            payloadItem['svcId'] = payloadItem.id;
            delete payloadItem.id;
            payload.push(payloadItem);
          }
        });
      }
      if (showType === SvcShowTypeEnum.JOB_OPTIONS) {
        await dispatch.sku.updateSvc({
          id: sku?.id,
          jobOptionDefs: payload,
          version: sku?.version,
        });
      } else if (showType === SvcShowTypeEnum.ADDITIONAL_JOB_OPTIONS) {
        await dispatch.sku.updateSvc({
          id: sku?.id,
          additionalJobOptionDefs: payload,
          version: sku?.version,
        });
      } else if (showType === SvcShowTypeEnum.REQUIRED) {
        await dispatch.sku.updateSvc({
          id: sku?.id,
          requiredSvcDefs: payload,
          version: sku?.version,
        });
      } else if (showType === SvcShowTypeEnum.OPTIONAL) {
        await dispatch.sku.updateSvc({
          id: sku?.id,
          optionalSvcDefs: payload,
          version: sku?.version,
        });
      }
      // const msg = await dispatch.jobConfig.updateJobSpec({
      //   skuId: spec.skuId,
      //   jobOptionDefs: payload,
      // });
      // if (typeof msg === 'string') {
      //   dispatch.jobConfig.setErrorStep(step);
      //   return false;
      // }
      // dispatch.jobConfig.resetErrorStep();
      return true;
    } catch {
      // dispatch.jobConfig.setErrorStep(step);
      return false;
    }
  });

  const showOptionSvcItem = useMemo(() => {
    if (showType === SvcShowTypeEnum.JOB_OPTIONS) {
      return optionSvc?.jobOptions;
    } else if (showType === SvcShowTypeEnum.REQUIRED) {
      return optionSvc?.requiredSvcGroup;
    } else if (showType === SvcShowTypeEnum.OPTIONAL) {
      return optionSvc?.optionalSvcGroup;
    } else if (showType === SvcShowTypeEnum.ADDITIONAL_JOB_OPTIONS) {
      return optionSvc?.additionalJobOptions;
    }
  }, [showType, optionSvc]);

  const defaultJobOption = useCallback(async () => {
    form.resetFields();
    dispatch.jobConfig.setRevxSpinloading(true);
    try {
      const svc = await dispatch.sku.getOptionSvcs({ id: sku.id });
      setOptionSvc(svc);
      let svcOption = [];
      if (showType === SvcShowTypeEnum.JOB_OPTIONS) {
        svcOption = svc.jobOptions;
      } else if (showType === SvcShowTypeEnum.REQUIRED) {
        svcOption = svc.requiredSvcGroup;
      } else if (showType === SvcShowTypeEnum.OPTIONAL) {
        svcOption = svc.optionalSvcGroup;
      } else if (showType === SvcShowTypeEnum.ADDITIONAL_JOB_OPTIONS) {
        svcOption = svc.additionalJobOptions;
      }

      let defaultFormData: { [x: string]: any } = {};
      let allSvcList: JobOptionSvc[] = [];

      [...svcOption].forEach((group) => {
        let groupSvcs = group.svcs;
        // groupSvcs.forEach((svc: JobOptionSvc) => {
        //   defaultFormData[svc.id] = {
        //     name: svc?.name,
        //   };
        // });
        if (group.exclusiveType === ExclusiveTypeEnum.ONE_OF) {
          groupSvcs = group.svcs.map((svc: { groupsId: any }) => {
            svc.groupsId = group.svcs.map((svc: { id: any }) => svc.id);
            return svc;
          });
        }

        allSvcList = [...allSvcList, ...groupSvcs];

        if (group.svcGroups) {
          group.svcGroups.forEach(
            (svcGroup: { svcs: any[]; exclusiveType: ExclusiveTypeEnum }) => {
              let groupSvcs = svcGroup?.svcs;

              if (svcGroup.exclusiveType === ExclusiveTypeEnum.ONE_OF) {
                groupSvcs = svcGroup?.svcs?.map((svc) => {
                  svc.groupsId = svcGroup.svcs.map((svc) => svc.id);
                  return svc;
                });
              }

              allSvcList = [...allSvcList, ...groupSvcs];
            }
          );
        }
      });
      setAllSvc(allSvcList);

      let svcDefs: JobOptionDef[] = [];
      if (showType === SvcShowTypeEnum.JOB_OPTIONS) {
        svcDefs = sku.jobOptionDefs || [];
      } else if (showType === SvcShowTypeEnum.REQUIRED) {
        svcDefs = sku.requiredSvcDefs || [];
      } else if (showType === SvcShowTypeEnum.OPTIONAL) {
        svcDefs = sku.optionalSvcDefs || [];
      } else if (showType === SvcShowTypeEnum.ADDITIONAL_JOB_OPTIONS) {
        svcDefs = sku.additionalJobOptionDefs || [];
      }
      if (
        [SvcShowTypeEnum.JOB_OPTIONS, SvcShowTypeEnum.REQUIRED].includes(
          showType
        )
      ) {
        [...svcOption].forEach((group) => {
          let groupSvcs = group.svcs;
          groupSvcs.forEach((svc: JobOptionSvc) => {
            defaultFormData[svc.id] = {
              name: svc?.name,
            };
          });
        });
        svcDefs.forEach((svc) => {
          const svcObj = allSvcList.find((item) => item.id === svc.svcId);
          if (svcObj?.groupsId) {
            const id = svcObj?.groupsId.join('') || 'oneof';
            defaultFormData[id] = {
              name: [id],
              svc: svcObj.id,
              instructions: svc.instructions,
            };
            svc.options?.forEach((option) => {
              if (option.label === 'Corner' && svc.revxId === 69) {
                defaultFormData[id]['Corner'] = option.values;
                if (option.values.length === 4) {
                  defaultFormData[id]['All'] = ['All'];
                } else {
                  defaultFormData[id]['All'] = [];
                }
              } else {
                defaultFormData[id][option.label] = option.values[0];
              }
            });
            if (svc.revxTypeId === 13) {
              defaultFormData['bundling'] = {
                svc: svc.svcId,
                quantityPerBundle: svc.quantityPerBundle,
                name: ['Bundling'],
              };
            }
            if (+svc.revxId === 15) {
              if (!defaultFormData[id]['perforate']) {
                defaultFormData[id]['perforate'] = [];
              }

              svc.specDefs.forEach((specDef) => {
                let parameterObj: { [x: string]: string | number } = {};
                specDef.parameters.forEach((parameter) => {
                  parameterObj[parameter.label] = parameter.parameter;
                  parameterObj['page'] = !specDef.perforateRange
                    ? 'All'
                    : 'Range';
                });
                parameterObj['rangeStart'] = specDef.perforateRange?.from;
                parameterObj['rangeTo'] = specDef.perforateRange?.to;
                defaultFormData[id]['perforate'].push(parameterObj);
              });
            }
            if (svc.quantityPerBundle) {
              defaultFormData[id]['quantityPerBundle'] = svc.quantityPerBundle;
            }
            if (!defaultFormData[id]['spec']) {
              defaultFormData[id]['spec'] = {};
            }
            svc.specDefs?.forEach((option) => {
              option?.parameters?.forEach((parameter) => {
                defaultFormData[id]['spec'][parameter.label] =
                  parameter.parameter;
              });
            });
          } else {
            defaultFormData[svc.svcId] = {
              name: [svc.name],
              instructions: svc.instructions,
            };
            svc.options?.forEach((option) => {
              if (option.label === 'Corner' && svc.revxId === 69) {
                defaultFormData[svc.svcId]['Corner'] = option.values;
                if (option.values.length === 4) {
                  defaultFormData[svc.svcId]['All'] = ['All'];
                } else {
                  defaultFormData[svc.svcId]['All'] = [];
                }
              } else {
                defaultFormData[svc.svcId][option.label] = option.values[0];
              }
            });
            if (svc.revxTypeId === 13) {
              defaultFormData['bundling'] = {
                svc: svc.svcId,
                quantityPerBundle: svc.quantityPerBundle,
                name: ['Bundling'],
              };
            }
            if (+svc.revxId === 15) {
              if (!defaultFormData[svc.svcId]['perforate']) {
                defaultFormData[svc.svcId]['perforate'] = [];
              }

              svc.specDefs.forEach((specDef) => {
                let parameterObj: { [x: string]: string | number } = {};
                specDef.parameters.forEach((parameter) => {
                  parameterObj[parameter.label] = parameter.parameter;
                  parameterObj['page'] = !specDef.perforateRange
                    ? 'All'
                    : 'Range';
                });
                parameterObj['rangeStart'] = specDef.perforateRange?.from;
                parameterObj['rangeTo'] = specDef.perforateRange?.to;
                defaultFormData[svc.svcId]['perforate'].push(parameterObj);
              });
            }
            if (svc.quantityPerBundle) {
              defaultFormData[svc.svcId]['quantityPerBundle'] =
                svc.quantityPerBundle;
            }
            if (!defaultFormData[svc.svcId]['spec']) {
              defaultFormData[svc.svcId]['spec'] = {};
            }
            svc.specDefs?.forEach((option) => {
              option?.parameters?.forEach((parameter) => {
                defaultFormData[svc.svcId]['spec'][parameter.label] =
                  parameter.parameter;
              });
            });
          }
        });
      } else {
        svcDefs.forEach((svc) => {
          const svcObj = allSvcList.find((item) => item.id === svc.svcId);
          if (svcObj?.groupsId) {
            const id = svcObj?.groupsId.join('') || 'oneof';
            defaultFormData[id] = {
              name: [id],
              svc: svcObj.id,
              instructions: svc.instructions,
            };
            svc.options?.forEach((option) => {
              if (option.label === 'Corner' && svc.revxId === 69) {
                defaultFormData[id]['Corner'] = option.values;
                if (option.values.length === 4) {
                  defaultFormData[id]['All'] = ['All'];
                } else {
                  defaultFormData[id]['All'] = [];
                }
              } else {
                defaultFormData[id][option.label] = option.values[0];
              }
              if (
                svc.revxId === 39 &&
                svc.revxTypeId === 17 &&
                option.label === 'Padding Edge'
              ) {
                const allForm = {
                  ...defaultFormData,
                };
                let defaultOptionValue = option.values;
                if (option.values[0] === allForm[38]?.['Adhesive Edge']) {
                  defaultOptionValue =
                    svcObj?.options
                      .find((item) => item.label === 'Padding Edge')
                      ?.values.filter(
                        (item) => item !== allForm[38]?.['Adhesive Edge']
                      ) || option.values;
                }
                defaultFormData[39]['Padding Edge'] = defaultOptionValue[0];
              }
            });
            if (+svc.revxId === 39 && +svc.revxTypeId === 17) {
              // defaultFormData[39]['quantityPerBundle'] = spec.pageCount;
            }
            if (svc.revxTypeId === 13) {
              defaultFormData['bundling'] = {
                svc: svc.svcId,
                quantityPerBundle: svc.quantityPerBundle,
                name: ['Bundling'],
              };
            }
            if (+svc.revxId === 15) {
              if (!defaultFormData[id]['perforate']) {
                defaultFormData[id]['perforate'] = [];
              }

              svc.specDefs.forEach((specDef) => {
                let parameterObj: { [x: string]: string | number } = {};
                specDef.parameters.forEach((parameter) => {
                  parameterObj[parameter.label] = parameter.parameter;
                  parameterObj['page'] = !specDef.perforateRange
                    ? 'All'
                    : 'Range';
                });
                parameterObj['rangeStart'] = specDef.perforateRange?.from;
                parameterObj['rangeTo'] = specDef.perforateRange?.to;
                defaultFormData[id]['perforate'].push(parameterObj);
              });
            }
            if (svc.quantityPerBundle) {
              defaultFormData[id]['quantityPerBundle'] = svc.quantityPerBundle;
            }
            if (svc.revxId === 40 && svc.revxTypeId === 17) {
              const allForm = {
                ...defaultFormData,
              };
              if (allForm[39]?.['quantityPerBundle']) {
                // defaultFormData[40]['quantityPerBundle'] = spec.pageCount;
              }
            }
            if (!defaultFormData[id]['spec']) {
              defaultFormData[id]['spec'] = {};
            }
            svc.specDefs?.forEach((option) => {
              option?.parameters?.forEach((parameter) => {
                defaultFormData[id]['spec'][parameter.label] =
                  parameter?.parameter;
              });
            });
          } else {
            defaultFormData[svc.svcId] = {
              name: [svc.name],
              instructions: svc.instructions,
            };
            svc.options?.forEach((option) => {
              if (option.label === 'Corner' && svc.revxId === 69) {
                defaultFormData[svc.svcId]['Corner'] = option.values;
                if (option.values.length === 4) {
                  defaultFormData[svc.svcId]['All'] = ['All'];
                } else {
                  defaultFormData[svc.svcId]['All'] = [];
                }
              } else {
                defaultFormData[svc.svcId][option.label] = option.values[0];
              }
              if (
                svc.revxId === 39 &&
                svc.revxTypeId === 17 &&
                option.label === 'Padding Edge'
              ) {
                const allForm = {
                  ...defaultFormData,
                };
                let defaultOptionValue = option.values;
                if (option.values[0] === allForm[38]?.['Adhesive Edge']) {
                  defaultOptionValue =
                    svcObj?.options
                      .find((item) => item.label === 'Padding Edge')
                      ?.values.filter(
                        (item) => item !== allForm[38]?.['Adhesive Edge']
                      ) || option.values;
                }
                defaultFormData[39]['Padding Edge'] = defaultOptionValue[0];
              }
            });
            if (+svc.revxId === 39 && +svc.revxTypeId === 17) {
              // defaultFormData[39]['quantityPerBundle'] = spec.pageCount;
            }
            if (svc.revxTypeId === 13) {
              defaultFormData['bundling'] = {
                svc: svc.svcId,
                quantityPerBundle: svc.quantityPerBundle,
                name: ['Bundling'],
              };
            }
            if (+svc.revxId === 15) {
              if (!defaultFormData[svc.svcId]['perforate']) {
                defaultFormData[svc.svcId]['perforate'] = [];
              }
              svc.specDefs.forEach((specDef) => {
                let parameterObj: { [x: string]: string | number } = {};
                specDef.parameters.forEach((parameter) => {
                  parameterObj[parameter.label] = parameter.parameter;
                  parameterObj['page'] = !specDef.perforateRange
                    ? 'All'
                    : 'Range';
                });
                parameterObj['rangeStart'] = specDef.perforateRange?.from;
                parameterObj['rangeTo'] = specDef.perforateRange?.to;
                defaultFormData[svc.svcId]['perforate'].push(parameterObj);
              });
            }
            if (svc.quantityPerBundle) {
              defaultFormData[svc.svcId]['quantityPerBundle'] =
                svc.quantityPerBundle;
            }
            if (!defaultFormData[svc.svcId]['spec']) {
              defaultFormData[svc.svcId]['spec'] = {};
            }
            svc.specDefs?.forEach((option) => {
              option?.parameters?.forEach((parameter) => {
                defaultFormData[svc.svcId]['spec'][parameter.label] =
                  parameter.parameter;
              });
            });
          }
        });
      }
      form.resetFields();
      form.setFieldsValue(defaultFormData);
      setFormCache(defaultFormData);
      dispatch.jobConfig.setRevxSpinloading(false);
    } catch {
      dispatch.jobConfig.setRevxSpinloading(false);
    }
  }, [sku, dispatch.jobConfig, dispatch.sku, form, showType]);

  useEffect(() => {
    defaultJobOption();
  }, [sku?.id, defaultJobOption]);

  const { run: debounceSubmit, cancel: cancelDebounceSubmit } = useDebounceFn(
    () => {
      submit();
    },
    { wait: 1500 }
  );

  return (
    <div className="jobconfig-jobOption-content">
      <Form
        form={form}
        onValuesChange={formChange}
        className={jobPartSvcHideBorder(optionSvc)}
      >
        {/* <div style={{ marginBottom: 20 }}></div> */}
        <RevxSvcContent
          svcGroups={showOptionSvcItem || []}
          {...componentDate}
          sku={sku}
          disabled={disabled}
          isSku={true}
        />
        {/* {allSvc
            ?.filter((svc) => !binderIdxArr.includes(svc.revxId))
            .map((svc, idx) => (
              <React.Fragment key={`${svc.revxTypeId} ${svc.revxId}`}>
                <ConfigSvcDetail
                  key={idx}
                  revxTypeId={svc.revxTypeId}
                  revxId={svc.revxId}
                  id={svc.id}
                  orientation={orientation}
                  {...componentDate}
                  jobOptionSvc={svc}
                />
              </React.Fragment>
            ))}
          {allSvc
            ?.filter((svc) => binderIdxArr.includes(svc.revxId))
            .map((svc, idx) => (
              <React.Fragment key={`${svc.revxTypeId} ${svc.revxId}`}>
                {idx === 0 ? (
                  <ConfigSvcDetail
                    key={idx}
                    revxTypeId={svc.revxTypeId}
                    revxId={svc.revxId}
                    id={svc.id}
                    orientation={orientation}
                    {...componentDate}
                    jobOptionSvcs={allSvc.filter((svc) =>
                      binderIdxArr.includes(svc.revxId)
                    )}
                  />
                ) : (
                  <></>
                )}
              </React.Fragment>
            ))} */}
      </Form>
    </div>
  );
};
